// Main Body types
export interface MainBody {
  id: string | number;
  name?: string;
  code?: string;
  description?: string;
  status?: number;
  shop_count?: number;
  created_at?: string;
  updated_at?: string;
}

export const MainBodyLabels = {
  name: '主体名称',
  code: '主体代码',
  description: '描述',
  status: '状态',
};
